import { createContext, useContext, useState, useEffect } from "react";
import { getRoleAccess } from "../services/apiServices";
import { fetchDefaultRoleAccess } from "../utils/defaultRoleAccess";


const AccessContext = createContext();

export const AccessProvider = ({ children }) => {
    const [roleAccess, setRoleAccess] = useState(null);
    const [classRoleAccess, setClassRoleAccess] = useState(null);
    const [loading, setLoading] = useState(true);
    const [rolename, setRolename] = useState([])

    // function to fetch access
    async function fetchAccess() {
        try {
            setLoading(true);
            const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo") || "null");

            if (!userInfo?.rolevalues) {
                console.log("No user role information found");
            }

            let access = {};

            try {
                const response = await getRoleAccess("easymembr", userInfo.rolevalues);
                if (response?.ok) {
                    const recinfo = await response.json();
                    access = recinfo?.access || {};
                    setRolename(recinfo?.roles || [])
                    // console.log('Role access fetched successfully:', recinfo);
                }
            } catch (primaryError) {
                console.warn("Primary role access failed, trying fallback:", primaryError);
            }


            if (Object.keys(access).length === 0) {
                try {
                    const defaultResponse = await fetchDefaultRoleAccess("easymembr", userInfo.rolevalues);
                    access = defaultResponse?.access || {};
                    console.log('Using default role access');
                    setRolename(defaultResponse?.roles || [])
                } catch (fallbackError) {
                    console.error("Fallback role access also failed:", fallbackError);
                }
            }

            setRoleAccess(access);
        } catch (err) {
            console.log("Critical error fetching access:", err);
            setRoleAccess({});
        } finally {
            setLoading(false);
        }
    }

    async function classFetchAccess() {
        try {
            const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
            if (!userInfo?.rolevalues) {
                setLoading(false);
                return;
            }

            let access = {};

            const response = await getRoleAccess("easybook", userInfo.rolevalues);

            if (response && response !== "false") {
                const recinfo = await response.json();
                if (recinfo) {
                    // console.log(recinfo, 'classRecinfo');
                    access = recinfo?.access || {};
                    setRolename(recinfo?.roles || [])
                }
            } else {
                const defaultResponse = await fetchDefaultRoleAccess("easybook", userInfo.rolevalues);
                access = defaultResponse?.access || {};
                setRolename(defaultResponse?.roles || [])
            }

            setClassRoleAccess(access);

        } catch (err) {
            console.error("Error fetching access:", err);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        fetchAccess();
        classFetchAccess();
    }, []);
    // console.log(roleAccess, 'roleAccess');
    const handlePageAccess = (page) => {
        // console.log(roleAccess, page);

        if (!roleAccess || !roleAccess[page]) {
            return null;
        }
        return roleAccess[page].accessinfo || {};
    };

    const handleClassPageAssess = (page) => {

        if (!classRoleAccess || !classRoleAccess[page]) {
            return null;
        }
        return classRoleAccess[page].accessinfo || {};
    }
    return (
        <AccessContext.Provider value={{ rolename, roleAccess, setRoleAccess, loading, fetchAccess, handlePageAccess, classRoleAccess, setClassRoleAccess, classFetchAccess, handleClassPageAssess }}>
            {children}
        </AccessContext.Provider>
    );
};

export const useAccess = () => useContext(AccessContext);
